<script setup lang="ts">
import { type WhiteLabelData } from "@web3auth/auth";
import base64url from "base64url";
import recursiveJSONParse from "json-stable-parse";
import { onBeforeMount } from "vue";
import { RouterView } from "vue-router";

import AppLayout from "@/components/AppLayout";
import useDappStore from "@/store/dappStore";

import { queryToJson } from "./utils/helpers";

const dappStore = useDappStore();

onBeforeMount(() => {
  const { state } = queryToJson(window.location.href);
  let whiteLabelData: WhiteLabelData | undefined;
  let isCustomVerifier = false;
  if (state) {
    const stateParams = JSON.parse(base64url.decode(state as string));
    if (stateParams.whiteLabel) whiteLabelData = recursiveJSONParse(stateParams.whiteLabel) as WhiteLabelData;
    if (stateParams.isCustomVerifier) isCustomVerifier = true;
  }
  dappStore.hydrateDapp(whiteLabelData, isCustomVerifier);
});
</script>

<template>
  <AppLayout>
    <RouterView />
  </AppLayout>
</template>
